import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button,
    ButtonToolbar,
    FormGroup,
    ControlLabel,
    FormControl
}                           from "react-bootstrap";
import axios              from "axios";
  import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import moment from 'moment'
import CrudComponent        from "./../zynappse-crud";
import schema_LifestyleBanner           from "./schema_LifestyleBanner";
import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_VALID
}                           from "utils";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class LifestyleBanner extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;
        
        this.refreshTable = this.refreshTable.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.getLifestyleBannerConfig = this.getLifestyleBannerConfig.bind(this);
        this.saveLifestyleBannerConfig = this.saveLifestyleBannerConfig.bind(this);
        this.accessible = this.accessible.bind(this);
        this.getNumberConfig = this.getNumberConfig.bind(this);
        this.saveNumberConfig = this.saveNumberConfig.bind(this);
    }

    refreshTable () {
        if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
            this.refreshTableReference();
        }
    }

    renderModalButton () {
        let {
            LifestyleBanner,
            actions
        } = this.props;

        let {
            formType,
            isLoadingAction
        } = LifestyleBanner;

        let buttons = [];

        let button = (name, callback) => (
            <Button
                bsStyle="primary"
                onClick={() => callback()}
                disabled={isLoadingAction}
            >
                {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
                {name}
            </Button>
        );

        let buttonClose = (
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        actions.setValue({
                            showModal: false
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    button("CREATE", this.saveData),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    button("UPDATE", this.saveData),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    button("DELETE", this.deleteData),
                    buttonClose
                );
                break;
            default:
                break;
        }
        return buttons;
    }

    async saveData () {
        let {
            LifestyleBanner,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId,

            image,
            browser,
            url,
            sort,
            isEasyPromos,
            promoId,
            visibilityType,
            visibilityStartTime,
            visibilityEndTime,
            campaignStartDate,
            campaignEndDate
        } = LifestyleBanner;

        const isVisibilityType_timeRage = (
            IS_VALID(visibilityType) &&
            visibilityType.value === "TR"
        );

        const getVisibilityTime = () => {
            let month = moment().month(),
                date = moment().date(),
                year = moment().year();

            if (!IS_VALID(visibilityStartTime)) {
                return "Visibility Start Time is required.";
            } else if (
                !moment(visibilityStartTime, "hh:mm A", true).isValid()
            ) {
                return "Please select a valid Visibility Start Time.";
            } else if (!IS_VALID(visibilityEndTime)) {
                return "Visibility End Time is required.";
            } else if (
                !moment(visibilityEndTime, "hh:mm A", true).isValid()
            ) {
                return "Please select a valid Visibility End Time.";
            } else if (
                moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBefore(moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
            ) {
                return "Visibility End Time should be greater Visibility Start Time";
            } else if (
                moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isSame(moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
            ) {
                return "Visibility Start Time and Visibility End Time should not be the same.";
            }
            // else if (
            //     moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year)) ||
            //     moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year))
            // ) {
            //     return "Visibility Time should not start/end between 12: 00 AM and 03:59 AM";
            // }

            return false;
        };

        const getVisibilityTime_result = getVisibilityTime();

        if (
            image === null
        ) {
            toast.error("Image is required.");
        } else if (
            IS_VALID(browser) &&
            (
                !IS_VALID(url) ||
                !IS_VALID(url.trim())
            )
        ) {
            toast.error("URL is required.");
        } else if (
            !IS_VALID(sort)
        ) {
            toast.error("Sort is required.");
        } else if (
            isEasyPromos &&
            !IS_VALID(promoId)
        ) {
            toast.error("Promo ID is required.");
        } else if (
            IS_VALID(browser) &&
            isEasyPromos &&
            url.toLowerCase().indexOf(promoId.toLowerCase()) === -1
        ) {
            toast.error("Cannot find Promo Id in URL");
        } else if (
            !IS_VALID(visibilityType)
        ) {
            toast.error("Visibility Type is required.");
        } else if (
            isVisibilityType_timeRage &&
            getVisibilityTime_result
        ) {
            toast.error(getVisibilityTime_result);
        } else if (
            IS_VALID(campaignStartDate) &&
            !moment(campaignStartDate, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid Campaign Start Date");
        } else if (
            IS_VALID(campaignEndDate) &&
            !moment(campaignEndDate, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid Campaign End Date");
        } else if (
            IS_VALID(campaignStartDate) &&
            IS_VALID(campaignEndDate) &&
            moment(campaignEndDate, "MMM DD, YYYY", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY", true))
        ) {
            toast.error("Campaign End Date should be greater than Campaign Start Date.");
        } else if (
            IS_VALID(campaignStartDate) &&
            IS_VALID(campaignEndDate) &&
            moment(campaignEndDate, "MMM DD, YYYY", true).isSame(moment(campaignStartDate, "MMM DD, YYYY", true))
        ) {
            toast.error("Campaign Start Date and Campaign End Date should not be the same.");
        } else if (
            (
                !IS_VALID(campaignStartDate) &&
                IS_VALID(campaignEndDate)
            ) ||
            (
                IS_VALID(campaignStartDate) &&
                !IS_VALID(campaignEndDate)
            )
        ) {
            toast.error("Please select a Campaign Start and End Date.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let fd = new FormData();

            fd.append("userId", Parse.User.current().id);
            fd.append("sort", sort);

            if (image.preview) {
                fd.append("image", image);
            } else {
                fd.append("isImageChange", false);
            }
            if (IS_VALID(browser)) {
                fd.append("browser", browser.value);

                fd.append("url", url.trim());

                fd.append("isEasyPromos", isEasyPromos);

                if (isEasyPromos) {
                    fd.append("promoId", promoId.trim());
                }
            }

            if (
                IS_VALID(visibilityType) &&
                IS_VALID(visibilityType.value)
            ) {
                fd.append('visibilityType', visibilityType.value); 
            }

            let month = moment().month(),
                date = moment().date(),
                year = moment().year();

            if (
                IS_VALID(visibilityStartTime) &&
                moment(visibilityStartTime, "hh:mm A", true).isValid()
            ) {
                fd.append('visibilityStartTime', moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format());
        
                fd.append('visibilityStartTime_string', moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A"));
            }
        
            if (
                IS_VALID(visibilityEndTime) &&
                moment(visibilityEndTime, "hh:mm A", true).isValid()
            ) {
                fd.append('visibilityEndTime', moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format());
                
                fd.append('visibilityEndTime_string', moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A"));
            }

            if (
                IS_VALID(campaignStartDate) &&
                IS_VALID(campaignEndDate)
            ) {
                fd.append('campaignStartDate', moment(campaignStartDate, "MMM DD, YYYY", true).startOf("d").format());

                fd.append('campaignEndDate', moment(campaignEndDate, "MMM DD, YYYY", true).endOf("d").format());
            }
            let httpMethod = "post",
                api_url = `${WEB_PATH}/LifestyleBanner`;

            if (
                (
                    !IS_EMPTY_STRING(formType) &&
                    formType.toUpperCase() === "UPDATE"
                ) &&
                !IS_EMPTY_STRING(formId)
            ) {
                httpMethod = "put";
                api_url = `${api_url}/${formId}`;
            }

            axios[httpMethod](api_url, fd)
            .then((res) => {
                let {
                    data,
                    changesObject
                } = res.data;

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    changesObject
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    deleteData () {
        let {
            LifestyleBanner,
            actions
        } = this.props;

        let {
            selectedData
        } = LifestyleBanner;

        actions.setValue({ isLoadingAction: true });

        selectedData.destroy()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    objectId: selectedData.id,
                    image: selectedData.get("image").url(),
                    browser: selectedData.get("browser") || "",
                    url: selectedData.get("url") || "",
                    sort: selectedData.get("sort") || 0
                }
            );
        })
        .catch((err) => {
            console.log("deleteData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        })
    }

    getLifestyleBannerConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoadingConfig: true
        });

        let customBlockMessageConfigQuery = new Parse.Query("LifestyleBannerConfig");

        customBlockMessageConfigQuery
        .equalTo("name", "LIFESTYLE")
        .descending("createdAt");

        customBlockMessageConfigQuery.first()
        .then((data) => {
            let stateToUpdate = {
                isLoadingConfig: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.isActive = IS_VALID(data.get("isActive")) ? data.get("isActive") : true;
                stateToUpdate.lifestyleBannerConfig = data;
            } else {
                stateToUpdate.isActive = true;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getLifestyleBannerConfig error");
            console.log(err);

            actions.setValue({
                isLoadingConfig: false
            });
        });
    }

    saveLifestyleBannerConfig () {
        let {
            LifestyleBanner,
            actions
        } = this.props;
        
        let {
            isActive,
            lifestyleBannerConfig
        } = LifestyleBanner

        actions.setValue({ isSavingConfig: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(lifestyleBannerConfig)) {
              resolve(lifestyleBannerConfig);
            } else {
              let query = new Parse.Query("LifestyleBannerConfig");
      
              query
              .equalTo("name", "LIFESTYLE")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((lifestyleBannerConfig) => {
            if (IS_UNDEFINED(lifestyleBannerConfig)) {
                lifestyleBannerConfig = new Parse.Object("LifestyleBannerConfig");

                lifestyleBannerConfig.set("name", "LIFESTYLE");
            }

            lifestyleBannerConfig
            .set("isActive", !isActive);

            return lifestyleBannerConfig.save();
        })
        .then((lifestyleBannerConfig) => {
            let stateToUpdate = {
                isSavingConfig: false,
                isActive: !isActive,
                showModalConfig: false,
                lifestyleBannerConfig
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                isActive ? "DEACTIVATE" : "ACTIVATE",
                {
                    isActive: !isActive
                }
            );
        })
        .catch((err) => {
            console.log("saveLifestyleBannerConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }
    
    accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

    getNumberConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            delayConfig_isLoading: true
        });

        let numberConfigQuery = new Parse.Query("NumberConfig");

        numberConfigQuery
        .equalTo("name", "LIFESTYLE")
        .descending("createdAt");

        numberConfigQuery.first()
        .then((data) => {
            let stateToUpdate = {
                delayConfig_isLoading: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.delayConfig = data;
                stateToUpdate.delayConfig_value = data.get("value") || 0;
            } else {
                stateToUpdate.delayConfig_value = 0;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getNumberConfig error");
            console.log(err);

            actions.setValue({
                delayConfig_isLoading: false
            });
        });
    }

    saveNumberConfig () {
        let {
            LifestyleBanner,
            actions
        } = this.props;
        
        let {
            delayConfig,
            delayConfig_value
        } = LifestyleBanner

        delayConfig_value = parseInt(delayConfig_value) || 0;

        if (
            delayConfig_value <= 0
        ) {
            return toast.error("Delay should not be zero.");
        }
        
        actions.setValue({ delayConfig_isSaving: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(delayConfig)) {
              resolve(delayConfig);
            } else {
              let query = new Parse.Query("NumberConfig");
      
              query
              .equalTo("name", "LIFESTYLE")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((numberConfig) => {
            if (IS_UNDEFINED(numberConfig)) {
                numberConfig = new Parse.Object("NumberConfig");

                numberConfig.set("name", "LIFESTYLE");
            }

            numberConfig
            .set("value", delayConfig_value*1000);

            return numberConfig.save();
        })
        .then((numberConfig) => {
            let stateToUpdate = {
                delayConfig_isSaving: false,
                delayConfig_showModal: false,
                delayConfig: numberConfig,
                delayConfig_value: delayConfig_value
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                "UPDATE",
                {
                    Delay: delayConfig_value
                }
            );
        })
        .catch((err) => {
            console.log("saveNumberConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    render () {
        let {
            LifestyleBanner,
            accessjson,
            actions
          } = this.props;
      
          let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            browserOptions,
            visibilityOptions,

            showModalConfig,
            isSavingConfig,
            isLoadingConfig,
            isActive,

            delayConfig_showModal,
            delayConfig_isSaving,
            delayConfig_isLoading,
            delayConfig,
            delayConfig_value
        } = LifestyleBanner;

        let crudProps = {
            schema: schema_LifestyleBanner,
            access: accessjson.access,
            moduleQuery: [
                { method: "ascending", column: "sort" }
            ],
            saveTrail: saveTrail,
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customView: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "VIEW",
                    formTitle: "VIEW LIFESTYLE BANNER",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE LIFESTYLE BANNER",
                    formId: "",
                    selectedData: null
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE LIFESTYLE BANNER",
                    formId: obj.id,
                    selectedData: obj
                };
                
                if (IS_VALID(obj.get("image"))) {
                    stateToUpdate.image = { url: obj.get("image").url(), name: obj.get("image").name() };
                }

                if (IS_VALID(obj.get("browser"))) {
                    let index = browserOptions.map(({ value }) => value).indexOf(obj.get("browser"));

                    if (index !== -1) {
                        stateToUpdate.browser = browserOptions[index];
                    }
                }

                if (IS_VALID(obj.get("url"))) {
                    stateToUpdate.url = obj.get("url");
                }

                if (IS_VALID(obj.get("sort"))) {
                    stateToUpdate.sort = obj.get("sort");
                }

                if (IS_VALID(obj.get("isEasyPromos"))) {
                    stateToUpdate.isEasyPromos = obj.get("isEasyPromos");
                }

                if (IS_VALID(obj.get("promoId"))) {
                    stateToUpdate.promoId = obj.get("promoId");
                }
    
                if (IS_VALID(obj.get("promoId"))) {
                    stateToUpdate.promoId = obj.get("promoId");
                }

                if (IS_VALID(obj.get("visibilityType"))) {
                    for (const item of visibilityOptions) {
                        if (
                            item.value === obj.get("visibilityType")
                        ) {
                            stateToUpdate.visibilityType = item;
                            break;
                        }
                    }
                }

                if (IS_VALID(obj.get("visibilityTimeConfig"))) {
                    const timeConfig = obj.get("visibilityTimeConfig");

                    let month = moment().month(),
                        date = moment().date(),
                        year = moment().year();

                    if (IS_VALID(timeConfig.start)) {
                        stateToUpdate.visibilityStartTime = moment(timeConfig.start, "hh:mm A", true).month(month).date(date).year(year);
                    }
                
                    if (IS_VALID(timeConfig.end)) {
                        stateToUpdate.visibilityEndTime = moment(timeConfig.end, "hh:mm A", true).month(month).date(date).year(year);
                    }
                }

                if (IS_VALID(obj.get("campaignStartDate"))) {
                    stateToUpdate.campaignStartDate = moment(obj.get("campaignStartDate"));
                }

                if (IS_VALID(obj.get("campaignEndDate"))) {
                    stateToUpdate.campaignEndDate = moment(obj.get("campaignEndDate"));
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE LIFESTYLE BANNER",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customItems: [
                {
                    columnName: "sort",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = "";
            
                        if (IS_VALID(object.get("sort"))) {
                            renderValue = object.get("sort");
                        }
            
                        return renderValue;
                    }
                }
            ]
        };

        let formContainerProps = {
            actions,

            selectedData,
            formType,
            
            visibilityOptions
        };

        let isActivateAccessible = this.accessible("ACTIVATE") === "",
            isDeactivateAccessible = this.accessible("DEACTIVATE") === "",
            isUpdateAccessible = this.accessible("UPDATE") === "";

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4 style={{ display: "inline-block" }}>Lifestyle Banner</h4>
                        <div style={{ float: "right" }}>
                            <ButtonToolbar>
                            <Button
                                style={(!isUpdateAccessible) ? { cursor: "not-allowed" } : null}
                                disabled={delayConfig_isLoading || !isUpdateAccessible}
                                onClick={() => {

                                    if (
                                       !isUpdateAccessible
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        delayConfig_showModal: true,
                                        delayConfig_value: (delayConfig.get("value") || 0)/1000
                                    });
                                }}
                            >
                                {delayConfig_isLoading ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    `${delayConfig ? (delayConfig.get("value") || 0)/1000 : 0}s`
                                )}
                            </Button>
                            <Button
                                style={(isActive ? !isDeactivateAccessible : !isActivateAccessible) ? { cursor: "not-allowed" } : null}
                                bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
                                disabled={isLoadingConfig || (isActive ? !isDeactivateAccessible : !isActivateAccessible)}
                                onClick={() => {

                                    if (
                                        (isActive ? !isDeactivateAccessible : !isActivateAccessible)
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        showModalConfig: true
                                    });
                                }}
                            >
                                {isLoadingConfig ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    isActive ? "ACTIVE" : "INACTIVE"
                                )}
                            </Button>
                            </ButtonToolbar>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={null}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={showModalConfig}
                    onHide={() => {
                        if (!isSavingConfig) {
                            actions.setValue({
                                showModalConfig: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "} LIFESTYLE BANNER</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {`Are you sure you want to ${isActive ? "deactivate" : "activate"} Lifestyle Banner?`}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle={isActive ? "danger" : "success"}
                            disabled={isSavingConfig}
                            onClick={() => this.saveLifestyleBannerConfig()}
                        >
                            {isActive ? "DEACTIVATE" : "ACTIVATE"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={delayConfig_showModal}
                    onHide={() => {
                        if (!delayConfig_isSaving) {
                            actions.setValue({
                                delayConfig_showModal: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>LIFESTYLE BANNER DELAY</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>Delay (seconds)</ControlLabel>
                            <FormControl
                                value={delayConfig_value}
                                onChange={(e) => {
                                    actions.setValue({
                                        delayConfig_value: e.target.value.replace(/[^0-9]/g, "")
                                    })
                                }}
                            />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle="primary"
                            disabled={delayConfig_isSaving}
                            onClick={() => this.saveNumberConfig()}
                        >
                            SAVE
                        </Button>
                        <Button
                            disabled={delayConfig_isSaving}
                            onClick={() => {
                                if (!delayConfig_isSaving) {
                                    actions.setValue({
                                        delayConfig_showModal: false
                                    });
                                }
                            }}
                        >
                            CLOSE
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount () {
        this.getLifestyleBannerConfig();

        this.getNumberConfig();
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_LIFESTYLE_BANNER
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        LifestyleBanner
	} = state;
	return {
		accessjson,
        LifestyleBanner
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_LIFESTYLE_BANNER) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LifestyleBanner);


// WEBPACK FOOTER //
// ./components/LifestyleBanner/index.js